<div class="price-section" [formGroup]="priceForm">
  <div class="price-section__field">
    <mat-label>{{ 'inventory.price.priceLabel' | translate }}</mat-label>
    <mat-form-field appearance="outline">
      <input
        matInput
        type="number"
        formControlName="price"
        [placeholder]="'inventory.price.pricePlaceholder' | translate"
        step="0.01"
        min="0"
      />
      @let priceField = priceForm.get('price');
      @if (priceField?.hasError('required')) {
        <mat-error>{{ 'inventory.price.priceRequired' | translate }}</mat-error>
      }
      @if (priceField?.hasError('min')) {
        <mat-error>{{ 'inventory.price.priceMin' | translate }}</mat-error>
      }
    </mat-form-field>
  </div>

  <div class="price-section__promotion-toggle">
    <mat-checkbox formControlName="applyPromotion" color="primary">
      {{ 'inventory.price.applyPromotion' | translate }}
    </mat-checkbox>
  </div>

  @if (priceForm.get('applyPromotion')?.value) {
    <div class="price-section__promotion-fields">
      <div class="price-section__field">
        <mat-label>{{ 'inventory.price.promotionPrice' | translate }}</mat-label>
        <div
          class="price-section__promotion-wrapper"
          [class.has-error]="hasPromotionError"
          [class.is-focused]="isPromotionFocused()"
        >
          <mat-form-field appearance="outline" class="price-section__promotion-type">
            <mat-select
              formControlName="promotionType"
              (focus)="onPromotionFocus()"
              (blur)="onPromotionBlur()"
            >
              @for (type of promotionTypes; track type.key) {
                <mat-option [value]="type.value">
                  {{ type.label }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="price-section__promotion-value">
            <input
              matInput
              type="number"
              formControlName="promotionValue"
              placeholder="0.00"
              step="0.01"
              min="0"
              [max]="priceForm.get('promotionType')?.value === 'percentage' ? 100 : null"
              (focus)="onPromotionFocus()"
              (blur)="onPromotionBlur()"
            />
          </mat-form-field>
        </div>
        @let promotionField = priceForm.get('promotionValue');
        @if (promotionField?.hasError('required')) {
          <span class="price-section__error">
            {{ 'inventory.price.promotionRequired' | translate }}
          </span>
        }
        @if (promotionField?.hasError('min')) {
          <span class="price-section__error">{{ 'inventory.price.promotionMin' | translate }}</span>
        }
        @if (promotionField?.hasError('max')) {
          <span class="price-section__error">{{ 'inventory.price.promotionMax' | translate }}</span>
        }
      </div>

      <div class="price-section__date-wrapper">
        <div class="price-section__field">
          <mat-label>{{ 'inventory.price.startDate' | translate }}</mat-label>
          <mat-form-field appearance="outline">
            <input
              matInput
              [matDatepicker]="startPicker"
              formControlName="promotionStartDate"
              placeholder="YYYY-MM-DD"
            />
            <mat-datepicker-toggle matIconSuffix [for]="startPicker" />
            <mat-datepicker #startPicker />
          </mat-form-field>
        </div>

        <div class="price-section__field">
          <mat-label>{{ 'inventory.price.endDate' | translate }}</mat-label>
          <mat-form-field appearance="outline">
            <input
              matInput
              [matDatepicker]="endPicker"
              formControlName="promotionEndDate"
              placeholder="YYYY-MM-DD"
            />
            <mat-datepicker-toggle matIconSuffix [for]="endPicker" />
            <mat-datepicker #endPicker />
          </mat-form-field>
        </div>
      </div>
    </div>
  }
</div>
